export default "__VITE_ASSET__CfcpMYFC__"